import { Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ApproveStepEntity, CreateNewExecutionInfoEntity, IdNameEntity, NameValueEntity, RefuseStepEntity, ResultStepEntity, SingleStepEntity } from '../pages/tool/pnrr/entities/pnrr-entites';
import { PNRRExecutionTemplateEntity, PNRRTemplateMetadataEntity } from '../pages/tool/pnrr/entities/pnrr-entites';

@Injectable({
  providedIn: 'root'
})
export class PnrrToolService {
  constructor(
    private http: HttpClient,
    private router: Router,
  ) { }
    //get(s)............................
    async getAllTemplates(): Promise<PNRRTemplateMetadataEntity[]> {
        return await this.http.get<PNRRTemplateMetadataEntity[]>(`${environment.apiUrl}/PNRR/getAllTemplates`).toPromise().then(r => r)
    }
    async getExecutionType() {
        return await this.http.get(`${environment.apiUrl}/PNRR/getExecutionType`).toPromise().then(r => r)
    }
    async getCompanies() {
        return await this.http.get(`${environment.apiUrl}/PNRR/getCompanies`).toPromise().then(r => r)
    }
    async getRoutingInfo() {
        return await this.http.get(`${environment.apiUrl}/PNRR/getRoutingInfo`).toPromise().then(r => r)
    }
    async getInputTypesInfo() {
        return await this.http.get(`${environment.apiUrl}/PNRR/getInputTypesInfo`).toPromise().then(r => r)
    }
    async getValidationTypes() {
        return await this.http.get(`${environment.apiUrl}/PNRR/getValidationTypes`).toPromise().then(r => r)
    }
    

    //post(s)..........................
    async getUrlForExecution(id: string) {
        return await this.http.post(`${environment.apiUrl}/PNRR/getUrlForExecution`, {name : id}).toPromise().then(r => r)
    }
    async saveTemplate(data: PNRRExecutionTemplateEntity) {
        return await this.http.post(`${environment.apiUrl}/PNRR/saveTemplate`, data).toPromise().then(r => r)
    }
    async getApplicationTemplates(type: Object) {
        return await this.http.post(`${environment.apiUrl}/PNRR/getApplicationTemplates `, type).toPromise().then(r => r)
    }
    async getAvailableAssessments(client: object, template: Object) {
        return await this.http.post(`${environment.apiUrl}/PNRR/getAvailableAssessments `, { client: client, template: template }).toPromise().then(r => r)
    }
    async sendInputFile ( e : SingleStepEntity){
        return await this.http.post(`${environment.apiUrl}/PNRR/uploadStepData `, e).toPromise().then(r => r)
    }
    async createNewExecution ( e : CreateNewExecutionInfoEntity){
    return await this.http.post(`${environment.apiUrl}/PNRR/createNewExecution `, e).toPromise().then(r => r)
    }
    async activateTemplate(e : PNRRTemplateMetadataEntity) {
        return await this.http.post(`${environment.apiUrl}/PNRR/changeActivateTemplate`, e).toPromise().then(r => r)
    }
    async getStepFromExecution ( e : IdNameEntity){
        return await this.http.post(`${environment.apiUrl}/PNRR/getStepFromExecution`, e ).toPromise().then(r => r)
    }
    async getTemplate(e: PNRRTemplateMetadataEntity) {
        return await this.http.post(`${environment.apiUrl}/PNRR/getTemplate`, e).toPromise().then(r => r)
    }
    async getStepToBeValidatedFromExecution ( e : IdNameEntity){
        return await this.http.post(`${environment.apiUrl}/PNRR/getStepToBeValidatedFromExecution`, e ).toPromise().then(r => r)
    }
    async approveStep(e: ApproveStepEntity) {
        return await this.http.post(`${environment.apiUrl}/PNRR/approveStep`, e ).toPromise().then(r => r)
    }
    async rejectStep(e: RefuseStepEntity) {
        return await this.http.post(`${environment.apiUrl}/PNRR/rejectStep`, e ).toPromise().then(r => r)
    }
    async rejectApplication(e: RefuseStepEntity) {
        return await this.http.post(`${environment.apiUrl}/PNRR/rejectApplication`, e ).toPromise().then(r => r)
    }
  
    async getAllExecutions() {
        return await this.http.get(`${environment.apiUrl}/PNRR/getAllExecutions` ).toPromise().then(r => r)
    }

    async getClientFromExecution(e: IdNameEntity) {
        return await this.http.post(`${environment.apiUrl}/PNRR/getClientFromExecution`, e ).toPromise().then(r => r)
    }
    async getFinalFile(e : IdNameEntity) {
        // console.log(e);
        return await this.http.post(`${environment.apiUrl}/PNRR/getFinalFile`, e).toPromise().then(r => r)
    }
}
